export var LoginError;
(function (LoginError) {
    LoginError[LoginError["Unknown"] = 0] = "Unknown";
    LoginError[LoginError["WrongAuthData"] = 1] = "WrongAuthData";
    LoginError[LoginError["NoResponseFromController"] = 2] = "NoResponseFromController";
    LoginError[LoginError["AuthDisabled"] = 3] = "AuthDisabled";
    LoginError[LoginError["MethodNotSupported"] = 4] = "MethodNotSupported";
})(LoginError || (LoginError = {}));
//# sourceMappingURL=ISessionService.js.map